/* eslint-disable react/no-unknown-property */
import { Icon } from '@pypestream/design-system';
import React, { ReactNode, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { tableStore } from '../../stores/table-store';

interface SelectPlaceholderProps {
  children: ReactNode;
  onOpen: () => void;
  ariaLabel: string;
  style?: React.CSSProperties;
  className?: string;
  testId?: string;
}

export const SelectPlaceholder: React.FC<SelectPlaceholderProps> = observer(
  ({ children, onOpen, ariaLabel, style = {}, className, testId }) => {
    const [isSelectedCell, setIsSelectedCell] = useState(false);

    return (
      <div
        test-id={testId}
        id="select-placeholder"
        className={`c-editor-table-select-placeholder ${className}`}
        style={style}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            tableStore.isCellBeingEdited = true;
            onOpen();
          }
        }}
        onClick={() => {
          if (
            isSelectedCell ||
            (tableStore.isCellBeingEdited && !isSelectedCell)
          ) {
            tableStore.isCellBeingEdited = true;
            onOpen();
          } else {
            setIsSelectedCell(true);
          }
        }}
        role="button"
        aria-label={ariaLabel}
      >
        <span className="c-editor-table-select-placeholder__text">
          {children}
        </span>
        <span
          className="c-editor-table-select-placeholder__icon"
          role="button"
          tabIndex={0}
          onClick={() => {
            tableStore.isCellBeingEdited = true;
            onOpen();
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              tableStore.isCellBeingEdited = true;
              onOpen();
            }
          }}
        >
          <Icon name="chevron-down" aria-hidden="true" />
        </span>
      </div>
    );
  }
);
